<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            <span>Hekim Listesi</span>
            <span>
                <export-excel
                        class="btn btn-default"
                        :data="excelTable"
                        worksheet="My Worksheet"
                        name="hekimlistesi.xls">
                             <el-tooltip content='Excel'
                                         :open-delay="200"
                                         placement="bottom">
                                <el-button size="mini"
                                           style="position: absolute;
                                                    top: 3px;
                                                    right: 35px;
                                                    color: white;"
                                           v-on:click="getHekimListesi1"
                                           type="text"
                                           icon="mdi mdi-file-excel mdi-18px">
                                </el-button>
                            </el-tooltip>
                </export-excel>
            </span>
        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col class="margin-bottom-10" :lg="24" :md="24" :sm="24" :xs="24">
                <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                text-color="gray">
                    <el-radio-button label="1">
                        <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                        <span style="color: #13ce66" class="durum">Aktif Hekimler</span>
                    </el-radio-button>
                    <el-radio-button label="0" v-if="root || admin || bayi || yonetici">
                        <i class="mdi mdi-account-remove mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                        <span style="color: #ec205f" class="durum">Pasif Hekimler</span>
                    </el-radio-button>
                </el-radio-group>
                <div class="aciklamaListesi">
                    <ul>
                        <li class="renk-duzenle"><i class="el-icon-edit"></i> Güncelle</li>
                        <li class="renk-silinen"><i class="mdi mdi-close"></i> Pasif Yap</li>
                        <li class="renk-detay"><i class="mdi mdi-account"></i> Hekim Detay</li>
                        <li class="renk-tamamlandi"><i class="mdi mdi-check"></i> Onayla</li>
                    </ul>
                </div>
            </el-col>
            <el-table
                    border
                    :data="hekimListesi"
                    ref="filterTable"
                    stripe
                    :row-key="row => row.hekimId"
                    :expand-row-keys="expandRowKeys"
                    @expand-change="handleExpandChange"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        sortable
                        label="Hekim ID"
                        prop="hekimId"
                        width="110">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="300">
                </el-table-column>
                <el-table-column
                        label="Klinik"
                        width="200">
                    <template slot-scope="scope">
                        <ul v-for="klnk in scope.row.klinik" style="padding: 0;">
                                <el-tag type="success">{{klnk.il}} - {{klnk.baslik}}</el-tag>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="telefon"
                        label="Telefon"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="eposta"
                        label="E-posta"
                        width="auto">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="kayitTarihi"
                        label="Kayıt Tarihi"
                        width="180">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="150">
                    <template slot="header" slot-scope="scope">
                            <el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                      placeholder="Ara" size="mini"></el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip v-if="selectIcon !== '2'" content='Hekim Güncelle' :open-delay="200"
                                    placement="bottom">
                            <el-button
                                    v-on:click="hekimDuzenle(scope.row)"
                                    type="text"
                                    class="buttonEdit ozel-buton-duzen"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon !== '2'" content='Hekim Detay' :open-delay="200"
                                    placement="bottom">
                            <el-button
                                    v-on:click="hekimDetay(scope.row)"
                                    type="text"
                                    class="buttonEdit ozel-buton-duzen"
                                    icon="el-icon-user" style="color: #0075c3">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip content='Onayla' :open-delay="200"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon === '0'"
                                    class="buttonSuc ozel-buton-duzen"
                                    @click="hekimDurumChange(scope.row,scope.$index,hekimListesi,'1')"
                                    type="text"
                                    icon="el-icon-check" style="color: #13ce66">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-if="root || admin || bayi || yonetici" content='Pasif Yap' :open-delay="200"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon === '1'"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    class="buttonDel ozel-buton-duzen"
                                    type="text"
                                    icon="el-icon-close">
                            </el-button>
                        </el-tooltip>

                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <hekim-guncelleme v-if="dialogVisibleHekimGuncelle" v-on:updatePage="getHekimListesi"
                          :dialogvisible.sync="dialogVisibleHekimGuncelle"
                          :userdatahekim="userdatahekim"></hekim-guncelleme>

        <hekim-detay v-if="dialogHekimDetay" :userdatahekim="userdatahekim" :dialogvisible.sync="dialogHekimDetay"></hekim-detay>


        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>"{{selection.adSoyad}}" hekimini pasife çekmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="hekimDurumChange(selection,selectionIndex,hekimListesi,'0'), deleteDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import hekimService from '../../../WSProvider/HekimService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import HekimGuncelleme from '@/components/HekimGuncelleme'
    import HekimDetay from '@/components/HekimDetay'
    import EventBus from '@/components/event-bus'

    import Vue from 'vue'
    import excel from 'vue-excel-export'

    Vue.use(excel)
    let base64 = require('base64_js');
    let userData3H = "";
    export default {
        name: "HekimListesi",
        components: {
            HekimGuncelleme,
            HekimDetay
        },
        mounted() {
            this.hekimCount();
            this.getHekimListesi();
            let self = this;
            EventBus.$on('hekimList', function (bool) {
                if (bool) {
                    self.hekimCount();
                    self.getHekimListesi();
                }
            });

            if (localStorage.getItem("userData3H")) {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["tur"]) {
                    if (userData3H["tur"] === '1') {
                        this.root = true;
                    } else if (userData3H["tur"] === '2') {
                        this.admin = true;
                    } else if (userData3H["tur"] === '3') {
                        this.bayi = true;
                    } else if (userData3H["tur"] === '4') {
                        this.yonetici = true;
                    } else if (userData3H["tur"] === '5') {
                        this.personel = true;
                    }
                }

            }
        },
        data() {
            return {
                excelTable: [],
                dialogMesajVisible: false,
                mailForm: {
                    mesaj: ''
                },
                expandRowKeys: [],
                page: 0,
                sizes: 20,
                postPage: 0,
                total: null,
                userdata: {},
                userdatahekim: {},
                dialogVisibleHasta: false,
                dialogVisibleHekimGuncelle: false,
                deleteDialogVisible: false,
                dialogHekimDetay: false,
                selectIcon: '1',
                radio: '1',
                root: false,
                search: '',
                selection: '',
                selectionIndex: '',
                durum: '',
                hekimListesi: [],
                filtersProje: [],
                filtersSorumlu: [],


                admin: false,
                bayi: false,
                yonetici: false,
                personel: false,
            }
        },
        methods: {
            handleExpandChange (row, expandedRows) {
                const hekimId = row.hekimId;
                // this.getProjeList(hekimId);
                const lastId = this.expandRowKeys[0];
                this.expandRowKeys = hekimId === lastId ? [] : [hekimId];
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getHekimListesi();
            },
            hekimCount() {
                hekimService.hekimCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getHekimListesi();
            },
            handleChange(event) {
                this.page = 0
                this.sizes = 20
                this.postPage = 0
                this.total = null
                this.selectIcon = event;
                this.hekimCount();
                this.getHekimListesi();
            },
            hekimDuzenle(scope) {
                this.userdatahekim = scope;
                this.dialogVisibleHekimGuncelle = true;
            },
            hekimDetay(scope) {
                this.userdatahekim = scope;
                this.dialogHekimDetay = true;
            },
            getHekimListesi() {
                let self = this;
                hekimService.hekimList(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {

                        this.hekimListesi=[];
                        response.data.forEach(function (e) {
                            var obj = self.hekimListesi.find(data => data.hekimId === e.hekimId);
                            if (obj === undefined) {
                                self.hekimListesi.push(e)
                            }
                        });


                        // this.hekimListesi = response.data;

                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            getHekimListesi1() {
                let self = this;
                hekimService.hekimList(this.selectIcon, "", "").then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {};
                            item["Hekim Kodu"] = e.hekimKodu;
                            item["İsim Soyisim"] = e.adSoyad;
                            item["Telefon"] = e.telefon;
                            item["Klinik"] = e.klinik;
                            item["adres"] = e.adres;
                            self.excelTable.push(item);
                        });
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            route(name, scope) {
                this.$store.commit('changeHekimKodu', scope.hekimKodu);
                var tabList = this.$store.state.tabList;
                var header = functions.linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            hekimDurumChange(selection, index, list, durum) {
                hekimService.hekimDurumGuncelle(selection.hekimId, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                notification.Status("success", this, "Hekim Pasife çekildi.");
                                break;
                            case '1':
                                notification.Status("success", this, "Hekim Aktife çekildi.");
                                break;
                        }
                        list.splice(index, 1);
                    }
                })
            },
            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    hekimService.hekimSearch(val).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.hekimListesi = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            clearable() {
                this.hekimListesi = [];
                this.hekimCount();
                this.getHekimListesi();
            },
        }
    }
</script>

<style lang="scss">
    .el-table .info-row {
        background: rgba(125, 199, 225, 0.45);
    }

    .el-table .error-row {
        background: rgba(249, 0, 26, 0.08);
    }

    .el-table .success-row {
        background: rgba(3, 249, 0, 0.08);
    }

    .el-table .warning-row {
        background: rgba(245, 249, 0, 0.08);
    }
</style>
<style lang="scss" scoped>
    .durum {
        position: relative;
        bottom: 3px;
    }
    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: rotate(360deg);
    }

    .el-pagination {
        float: right;
    }

    /*.el-radio-button--mini .el-radio-button__inner label {*/
    /*position: relative;*/
    /*bottom: 5px;*/
    /*}*/

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .ozel-buton-duzen {
        position: static !important;
        margin-left: 0 !important;
        font-size: 20px !important;
    }

    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 5px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }

    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

</style>